import { ChangeDetectionStrategy, Component, inject, model } from '@angular/core';

import { TranslocoPipe } from '@jsverse/transloco';
import type { BadgeVariant } from '@mercadoni/stark-ui';
import {
  SkBadgeComponent,
  SkButtonComponent,
  SkDrawerComponent,
  SkEmptyStateComponent,
  SkIconComponent,
  SkWhatsNewFeedComponent,
} from '@mercadoni/stark-ui';

import type { NotificationStatus, ServerNotification } from '../../core/interfaces';
import { NotificationsService, StatusMapperService } from '../../core/services';
import { LocaleService } from '../../core/services/i18n/locale.service';
import { NfDatePipe } from '../../shared/pipes/nf-date.pipe';

@Component({
  selector: 'nf-notifications-drawer',
  imports: [
    TranslocoPipe,
    NfDatePipe,
    SkDrawerComponent,
    SkBadgeComponent,
    SkButtonComponent,
    SkIconComponent,
    SkEmptyStateComponent,
    SkWhatsNewFeedComponent,
  ],
  templateUrl: './notifications-drawer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NfNotificationsDrawerComponent {
  protected readonly dateLocale = inject(LocaleService).dateLocale;
  readonly service = inject(NotificationsService);
  private readonly statusMapper = inject(StatusMapperService);

  open = model(false);

  badgeVariant(status: NotificationStatus): BadgeVariant {
    return this.statusMapper.getNotificationBadge(status);
  }

  statusIcon(status: NotificationStatus): string {
    return this.statusMapper.getNotificationIcon(status);
  }

  openDetail(notif: ServerNotification): void {
    this.service.openDetail(notif);
  }
}
